import classNames from 'classnames';
import React from 'react';

import MenuItemLink from '../MenuItemLink';

const MenuItem = ({ item, className, linkClassName }) => {
    return (
        <li className={classNames('side-nav-item', className)}>
            <MenuItemLink item={item} className={linkClassName}/>
        </li>
    );
};


export default MenuItem;